import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './AuthContext';
import { ToastProvider } from './context/ToastContext';
import ProtectedRoute from './ProtectedRoute';
import HomePage from './pages/HomePage';
import CardinauxPage from './pages/CardinauxPage';
import PapabiliPage from './pages/PapabiliPage';
import PapabileAdmin from './pages/PapabileAdmin';
import PapabileDuJourPage from './pages/PapabileDuJourPage';
import PapabileDuJourArchivePage from './pages/PapabileDuJourArchivePage';
import PapabileDuJourAdmin from './pages/PapabileDuJourAdmin';
import ConclaveVirtuelPage from './pages/ConclaveVirtuelPage';
import CardinalDetail from './components/CardinalDetail';
import LoginPage from './pages/LoginPage';
import Admincardinaux from './pages/Admincardinaux';
import AdminCardinalsList from './pages/AdminCardinalsList';
import ConclaveAdminPage from './pages/ConclaveAdminPage';
import EditCardinal from './pages/EditCardinal';
import NotFoundPage from './pages/NotFoundPage';
import Header from './components/Header';
import Footer from './components/Footer';
import QuizPage from './pages/QuizPage';
import QuizAdmin from './pages/QuizAdmin';
import MetaTags from './components/MetaTags';
// Nouveaux imports pour les articles
import ArticleListPage from './pages/ArticleListPage';
import ArticleDetailPage from './pages/ArticleDetailPage';
import ArticleAdmin from './pages/ArticleAdmin';
import ArticleForm from './pages/ArticleForm';

// Ajouter les imports pour les galleries
import GalleryListPage from './pages/GalleryListPage';
import GalleryDetailPage from './pages/GalleryDetailPage';
import GalleryDownloadPage from './pages/GalleryDownloadPage';
import GalleryAdmin from './pages/GalleryAdmin';
import GalleryImagesAdmin from './pages/GalleryImagesAdmin';
import DownloadStatsAdmin from './pages/DownloadStatsAdmin';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <MetaTags 
            title="Conclave 2025" 
            description="Le site officiel du Conclave 2025 avec annuaire, syst�me de vote et informations sur le conclave" 
            url=""
          />
          <div className="App">
            <Header />
            <main>
              <div className="container">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/cardinaux" element={<CardinauxPage />} />
                  <Route path="/papabili" element={<PapabiliPage />} />
                  <Route path="/papabile-du-jour" element={<PapabileDuJourPage />} />
                  <Route path="/papabile-du-jour/:slug" element={<PapabileDuJourPage />} />
                  <Route path="/papabile-du-jour/archive" element={<PapabileDuJourArchivePage />} />
                  <Route path="/conclave" element={<ConclaveVirtuelPage />} />
                  <Route path="/quiz" element={<QuizPage />} />
                  <Route path="/cardinaux/:slug" element={<CardinalDetail />} />
                  <Route path="/login" element={<LoginPage />} />
                  {/* Routes pour les articles */}
                  <Route path="/actualites" element={<ArticleListPage />} />
                  <Route path="/actualites/:slug" element={<ArticleDetailPage />} />
                  <Route path="/galeries" element={<GalleryListPage />} />
				<Route path="/galeries/:slug" element={<GalleryDetailPage />} />
				<Route path="/gallery/download/:token" element={<GalleryDownloadPage />} />
				  
				  
                  {/* Routes d'administration */}
                  <Route 
                    path="/admin/cardinaux" 
                    element={
                      <ProtectedRoute requireAdmin={true}>
                        <Admincardinaux />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin/cardinaux/liste" 
                    element={
                      <ProtectedRoute requireAdmin={true}>
                        <AdminCardinalsList />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin/cardinaux/edit/:id" 
                    element={
                      <ProtectedRoute requireAdmin={true}>
                        <EditCardinal />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin/cardinaux/papabile/:id" 
                    element={
                      <ProtectedRoute requireAdmin={true}>
                        <PapabileAdmin />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin/papabile-jour" 
                    element={
                      <ProtectedRoute requireAdmin={true}>
                        <PapabileDuJourAdmin />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin/conclave" 
                    element={
                      <ProtectedRoute requireAdmin={true}>
                        <ConclaveAdminPage />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin/quiz" 
                    element={
                      <ProtectedRoute requireAdmin={true}>
                        <QuizAdmin />
                      </ProtectedRoute>
                    } 
                  />
                  {/* Nouvelles routes d'administration d'articles */}
                  <Route 
                    path="/admin/articles" 
                    element={
                      <ProtectedRoute requireAdmin={true}>
                        <ArticleAdmin />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin/articles/create" 
                    element={
                      <ProtectedRoute requireAdmin={true}>
                        <ArticleForm />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin/articles/edit/:id" 
                    element={
                      <ProtectedRoute requireAdmin={true}>
                        <ArticleForm />
                      </ProtectedRoute>
                    } 
                  />
				<Route 
					  path="/admin/gallery" 
					  element={
						<ProtectedRoute requireAdmin={true}>
						  <GalleryAdmin />
						</ProtectedRoute>
					  } 
					/>
					<Route 
					  path="/admin/gallery/:galleryId/images" 
					  element={
						<ProtectedRoute requireAdmin={true}>
						  <GalleryImagesAdmin />
						</ProtectedRoute>
					  } 
					/>	
					<Route 
					  path="/admin/gallery/download-stats" 
					  element={
					    <ProtectedRoute requireAdmin={true}>
					      <DownloadStatsAdmin />
					    </ProtectedRoute>
					  } 
					/>  
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </div>
            </main>
            <Footer />
          </div>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;